import { useMemo } from "react";
import { PROJECT_INTG_CONFIGS } from "services/graphQL/ciq-queries";
import { getGQL } from "utils/utils";
import { useQuerySubscription } from "./common";

export const useGetProjectINTGState = ({ skip, client }: any) => {
  getGQL(PROJECT_INTG_CONFIGS);

  const { query: qProjectIntgConfigs, sub: sProjectIntgConfigs } =
    useMemo(() => {
      return getGQL(PROJECT_INTG_CONFIGS);
    }, []);

  const { data, error } = useQuerySubscription(
    qProjectIntgConfigs,
    sProjectIntgConfigs,
    {
      client,
      skip
    }
  );

  const isIntegrationConfigured = !!(
    data && data?.project_integration_configs.length
  );

  return {
    data,
    error,
    isIntegrationConfigured
  };
};
